import 'react-datepicker/dist/react-datepicker.css';
import * as React from 'react';
import i18next from 'i18next';
import moment from 'moment';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import { Formik, Form, Field, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { Link, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { parsePhoneNumber } from 'libphonenumber-js';

import { Field as FieldContainer, Notification, FieldBody, Control, Title, Card, CardHeader, CardContent, Content, Columns, Column, Table, Button, Footer, Label } from 'bloomer';
import { AppState } from '../../store';
import { CustomerThunkDispatch } from '../../store/customerOverview/types';
import { FormField } from '../../components/FormField/FormField';
import { Page } from '../../styles/styled-components/Customer/Customer';
import { colors } from '../../styles/colors';
import { ReportLanguage, getEthnicityByPartner, GENDER, Gender, Ethnicity, PhoneType, Partner, CountryCode, EmailTagName, getPartnerPhoneNumber, } from '../../helpers/types';
import { actionFetchKitsByBarcode, actionDownloadPdfReport, actionResetCustomerDetails } from '../../store/customerDetails/actions';
import { Kit, Profile, ReportFile, Status, KitStatus, Test } from '../../models/customerOverview';
import { byDatetime, toMoment, toLocalTime, getPhoneNumber, isValidMobilePhone } from '../../helpers/helpers';
import { KitStatusIndicator } from '../../components/KitStatusIndicator/KitStatusIndicator';
import { isReportReady, isReportRelesed } from '../Customers/Customers';
import { LoadingIndicator } from '../../components/LoadingIndicator/LoadingIndicator';
import { REPORT_API_BASE_URL, TASSCARE_LANGUAGE, getPartner, getCustomerID } from '../../constants';
import { Authentication } from '../../models/authentication';
import HeaderDropdown from '../../components/HeaderDropdown/HeaderDropdown';
import { DownloadReportFormPayload, ProfileTransferPayload, ProfileTransfer } from '../../models/profile';
import { actionSetPageTitle } from '../../store/siteConfig/action';
import { SubmitButton } from '../../components/SubmitButton/SubmitButton';
import FormError from '../../components/FormError/FormError';
import { ProfileService } from '../../store/profile/effects';

import SelectField from '../../components/SelectField/SelectField';
import HealthService from '../../store/health/effects';
import { Profile as PayLoadProfile } from '../../models/profile';
import barcodeInfo from '../../assets/images/completed.png';
import SquareButton from '../../components/CustomButton/CustomButton';
import KitActivationPopup from '../CustomerDetails/Component/KitActivationPopup';
import ActivationPopup from '../../components/Popup/ActivtionPopup';
import { actionTransferProfile } from '../../store/profileTransfer/actions';
import ConfirmationPopup from '../../components/Popup/TransferPopUp/ConfirmationPopup';
import SelectFieldCountryCode from '../../components/SelectField/SelectFieldCountryCode';
import { ContryCodeContainer } from '../../styles/styled-components/Form/FormComponent';
import { getCurrentAppLang } from '../../helpers/util';

interface CustomerDetailsProps {
  fetchKitsByBarcode: (barcode: string) => Promise<void>;
  downloadPDFReport: (payload: DownloadReportFormPayload) => void;
  transferProfile: (payload: ProfileTransferPayload, partner: string) => void;
  setPageTitle: (title: React.ReactNode) => void;
  resetPage: () => void;
  authentication: Authentication;
  transfer: ProfileTransfer;
  customerDetails: {
    kit: Kit | undefined;
    profile: Profile | undefined;
    pdfLink: string;
  };
  customerOverview: {
    loading: boolean;
    kitsData: {
      kits: Kit[];
      total: number;
    };
    profiles: Record<string, Profile>;
    kitStatusFilter: KitStatus | undefined;
    searchTerm: string;
    currentPage: number;
  };
}

type CustomerDetailState = {
  isOpen: boolean;
  barcode: string;
  email: string;
  gender: Gender | undefined;
  ethnicity: Ethnicity | undefined;
  firstName: string;
  lastName: string;
  dob: string;
  phone: string;
  countryCode: string;
  status: any,
  timestamp: string
  remarks?: string;
  reports?: Test[];
  reportSelectedLang: string;
  kitHistory: Status[];
  isSaved: boolean;
  loading: boolean;
  profileTransferConfirm: {
    status: boolean,
    form: JSX.Element | undefined,
  };
  profileTransferSuccess: {
    status: boolean,
    form: JSX.Element | undefined,
  }
  profileTransferError: {
    status: boolean,
    form: JSX.Element | undefined,
  }
};

export function getKitTimeLines(kitData: Kit[]): Status[] {
  const statuses: Status[] = [];
  kitData && kitData.forEach((kitInfo: any) => { // tslint:disable-line:no-any
    kitInfo.test && kitInfo.test.forEach((historyInfo: { status: string; datetime: string; }) => {
      if (historyInfo.status === 'report-ready') {
        statuses.push({
          id: kitInfo.barcode || kitInfo.sampleId,
          status: historyInfo.status,
          datetime: moment(historyInfo.datetime),
        });
      }
    });
    kitInfo.history.forEach((historyInfo: { status: string; datetime: string; }) => {
      statuses.push({
        id: kitInfo.barcode || kitInfo.sampleId,
        status: historyInfo.status,
        datetime: moment(historyInfo.datetime),
      });
    });
    if (kitInfo.datetime) {
      statuses.push({
        id: kitInfo.barcode || kitInfo.sampleId,
        status: 'created',
        datetime: moment(kitInfo.datetime),
      });
    }
  });
  return statuses;
}
export function getTimeLines(kitData: Kit[]): Status[] {
  const statuses: Status[] = [];
  const isReportReady: boolean | undefined = kitData[0].test && kitData[0].test[0].status === 'report-ready';
  const isRejected: boolean = (kitData[0].status === 'rejected');
  const kitRegistered = kitData[0].history && kitData[0].history.find(history => {
    return history.status === 'activated';
  });
  if (kitRegistered) {
    statuses.push({
      status: i18next.t('statusTimeLine.kitRegistered.title'),
      datetime: moment(kitRegistered.datetime),
    });
  }
  const kitReady = kitData[0].history && kitData[0].history.find(history => {
    return history.status === 'ready';
  });

  if (kitReady) {
    statuses.push({
      status: i18next.t('statusTimeLine.sampleInLab.title'),
      datetime: moment(kitReady.datetime),
    });
  }
  if (kitData[0].expectedReportReadyDate && !isReportReady && !isRejected) {
    statuses.push({
      status: i18next.t('statusTimeLine.expectedReportReady.title'),
      datetime: moment(kitData[0].expectedReportReadyDate),
    });
  }
  if (kitData[0].test && kitData[0].test[0].status === 'report-ready') {
    const kitTestInfo = kitData[0].test[0].history.find(historyInfo => {
      return historyInfo.status === 'report-ready';
    });
    statuses.push({
      status: i18next.t('statusTimeLine.reportReady.title'),
      datetime: moment(kitTestInfo?.datetime),
    });
  }
  return statuses;
}

export function getTestHistories(kit: Kit): Status[] {
  const sortedTests = kit.test && kit.test.sort((t1, t2) => toMoment(t1.datetime).diff(toMoment(t2.datetime)));
  if (kit.test) {
    return kit.test.reduce<Status[]>((es, testInfo) => {
      const histories = testInfo.history;
      if (testInfo.status === 'test-terminated') {
        const index = sortedTests && sortedTests.findIndex(s => s.testId === testInfo.testId);
        if (sortedTests && index && sortedTests.length > index + 1) {
          histories.push({ status: 'test-terminated', datetime: sortedTests[index + 1].datetime });
        }
      }
      return es.concat(histories.map(historyInfo => ({
        id: `${testInfo.name} (${toLocalTime(testInfo.datetime, 'd')})`,
        status: historyInfo.status,
        datetime: toMoment(historyInfo.datetime),
      })));
    }, []);
  }
  return [];
}

const DatePickerField = ({ name, value, onChange }: any) => {
  const dob = value ? new Date(value) : null;
  return (
    <DatePicker
      selected={dob}
      className={'input'}
      placeholderText={i18next.t('form.dob.placeholder')}
      showYearDropdown
      strictParsing
      dateFormat="dd-MMM-yyyy"
      scrollableYearDropdown
      yearDropdownItemNumber={150}
      maxDate={new Date()}
      onChange={val => {
        onChange(name, val);
      }}
    />
  );
};

class CustomerDetails extends React.Component<CustomerDetailsProps & RouteComponentProps, CustomerDetailState> {

  state: CustomerDetailState = {
    isOpen: false,
    barcode: '',
    gender: undefined,
    ethnicity: undefined,
    firstName: '',
    lastName: '',
    email: '',
    dob: '',
    phone: '',
    countryCode: '-',
    status: '',
    timestamp: '',
    remarks: '',
    reports: undefined,
    loading: true,
    kitHistory: [],
    isSaved: false,
    reportSelectedLang: '',
    profileTransferConfirm: {
      status: false,
      form: undefined,
    },
    profileTransferSuccess: {
      status: false,
      form: undefined,
    },
    profileTransferError: {
      status: false,
      form: undefined,
    },
  };

  componentDidUpdate() {
    if (!(this.state.barcode && this.state.firstName)) {
      this.updateData();
    }
    if (!this.state.reportSelectedLang) {
      const defaultLanguage = getPartner() === Partner.TASSCARE ? 'en-VN' : 'en-HK';
      this.setState({ reportSelectedLang: defaultLanguage });
    }
  }

  componentWillUnmount() {
    this.props.resetPage();
  }

  mobileBackBtnClickHandler() {
    window.history.back();
  }

  updateData = () => {
    const { kit, profile } = this.props.customerDetails;
    const { kitStatusFilter } = this.props.customerOverview;
    if (kit && profile) {
      this.getDetails(kit, profile, kitStatusFilter);
    }
  }

  async componentDidMount() {
    if (this.props.match.params) {
      this.props.setPageTitle(
        <BreadcrumbLink className={'pageTitle'} to={'customers-management'}>
          <FontAwesomeIcon icon={faChevronLeft} />  {i18next.t('cmp.header')}
        </BreadcrumbLink>
      );
      const queryParams = new URLSearchParams(this.props.location.search);
      const urlBarCode = queryParams.get('code');
      if (urlBarCode) {
        await this.props.fetchKitsByBarcode(urlBarCode);
        this.setState({
          barcode: urlBarCode,
          loading: false,
        });
        this.updateData();
      }
    }
  }

  changeLanguage(selectedLang: string) {
    this.setState({ reportSelectedLang: selectedLang });
  }

  async downloadPDF() {
    const { profile } = this.props.customerDetails;
    if (profile) {
      await this.props.downloadPDFReport({ profileId: profile.profileId, owner: profile?.owner, lang: this.state.reportSelectedLang });
      const { pdfLink } = this.props.customerDetails;
      if (pdfLink) {
        window.location.href = this.props.customerDetails.pdfLink;
      }
    }
  }

  showNotification = () => {
    this.setState({ isSaved: true });
    setTimeout(() => this.setState({ isSaved: false }), 3000);
  }
  isRecollected = (profile: Profile, barcode: string | undefined) => {
    const { tag } = profile;
    return (tag.findIndex(s => s.tag.startsWith(`replaced:${barcode}`))) > 0 ? false : true;
  }

  async handleSubmit(values: CustomerDetailState, actions: FormikHelpers<CustomerDetailState>) {
    const { profile } = this.props.customerDetails;
    if (profile) {
      this.setState({ isSaved: true });
      const phone: any = (values.phone !== '-') ? parsePhoneNumber(`${values.countryCode}` + values.phone) : values.phone;
      let isHealthEdited = false;
      let isNameEdited = false;
      let isValidPhone = false;
      try {
        this.setState({
          firstName: values.firstName,
          lastName: values.lastName,
          gender: values.gender,
          dob: moment(values.dob).format('DD-MMM-YYYY'),
          ethnicity: values.ethnicity,
          phone: values.phone,
          countryCode: values.countryCode,
        });
        if ((profile.name.firstName !== values.firstName) || (profile.name.lastName !== values.lastName)) {
          isNameEdited = true;
        }
        if (values.gender && values.ethnicity && ((profile.health.dob !== moment(values.dob).format('YYYY-MM-DD')) || (profile.health.gender !== values.gender) || (profile.health.ethnicity !== values.ethnicity))) {
          isHealthEdited = true;
        }
        const { phoneNo, countryCode } = getPhoneNumber(profile.phone);
        if (values.phone && values.phone !== '-' && (`${countryCode}${phoneNo}` !== `+${phone.countryCallingCode}${phone.nationalNumber}`)) {
          isValidPhone = true;
        }
        if (isNameEdited || isHealthEdited || isValidPhone) {
          const editProfile: PayLoadProfile = {
            profile: {
              name: {
                lastName: values.lastName,
                firstName: values.firstName,
              },
              health: {
                dob: moment(values.dob).format('YYYY-MM-DD'),
                gender: String(values.gender),
                ethnicity: String(values.ethnicity),
                healthId: profile.health.healthId,
              },
              phone: {
                name: PhoneType.MOBILE + Number(Math.random() * 999),
                primary: true,
                detail: {
                  countryCode: `+${phone.countryCallingCode}`,
                  number: phone.nationalNumber,
                },
              },
            },
          };
          await HealthService.editBasicProfileHealth({
            isName: isNameEdited,
            isHeath: isHealthEdited,
            isPhone: isValidPhone,
            profileId: profile.profileId,
            profile: editProfile,
            partner: getPartner(),
            owner: profile?.owner || getCustomerID(),
          });
        }
        if (values.remarks && values.remarks !== '-') {
          const { kit } = this.props.customerDetails;
          await ProfileService.updateRemarks({
            kitId: kit?.kitId,
            content: values.remarks,
          });
          this.setState({
            remarks: '',
          });
          this.refresh(this.state.barcode);
        }
        this.showNotification();
      } catch (err) {
        actions.setStatus({ error: 'form.generic.error' });
      }
    }
  }

  render() {
    let downloadReport: React.ReactNode;
    const PARTNER = getPartner();
    const ETHNICITY = getEthnicityByPartner(PARTNER as Partner);
    const COUNTRY = getPartnerPhoneNumber(PARTNER as Partner);
    const { firstName, lastName, reportSelectedLang, reports, isSaved } = this.state;
    const { profile, kit } = this.props.customerDetails;
    const token = this.props.authentication.token;
    const mobileReportUrl = `${REPORT_API_BASE_URL}/report/home?bearerToken=${token}&profileId=${profile?.profileId}&xOwner=${profile?.owner}&language=${reportSelectedLang}`;
    const { profileTransferConfirm, profileTransferSuccess, profileTransferError } = this.state;
    const isRecollect = profile ? this.isRecollected(profile, kit?.barcode) : false;
    const validationSchema = Yup.object().shape({
      firstName: Yup.string().required('form.firstName.error.empty'),
      lastName: Yup.string().required('form.lastName.error.empty'),
      dob: Yup.date().required('form.dob.error.empty'),
      gender: Yup.string().required('form.sex.error.empty'),
      ethnicity: Yup.string().required('form.ethnicity.error.empty'),
      phone: Yup.string().required('form.phone.error.empty').test('hasChangedTest', 'form.phone.error.invalidFormat', isValidMobilePhone),
    });

    if (reports && reports.length && reports[0].files) {
      const reportsLang = reports[0].files.reduce<string[]>((lang, file: ReportFile) => lang.concat(file.language || [file.language]), []);
      switch (PARTNER) {
        case 'tasscare':
          downloadReport = <HeaderDropdown
            selected={reportSelectedLang || ReportLanguage.English}
            options={TASSCARE_LANGUAGE.map((language) => ({ title: language, value: language }))}
            callback={(e, selected) => this.changeLanguage(selected)
            }
          />;
          break;
        default:
          if (reportsLang.length) {
            downloadReport = <HeaderDropdown
              selected={reportSelectedLang || ReportLanguage.English}
              options={reportsLang.map((language) => ({ title: language, value: language }))}
              callback={(e, selected) => this.changeLanguage(selected)
              }
            />;
          }
          break;
      }
    }
    let barcodeField: React.ReactNode;

    barcodeField = <FormField name="barcode" label={i18next.t('cmp.table.title.barcode')} noError >
      {(kit?.status === 'rejected') ? <RejectedBarcodeView>{kit ? kit.barcode : ''}</RejectedBarcodeView> : kit ? kit.barcode : ''}
    </FormField>;

    const isShow = kit && profile ? this.isShowReportRelease(kit, profile) : false;
    const isReportReady = (kit && kit.status === 'ready' && kit.test !== undefined && kit.test.some(test => test.status === 'report-ready'));
    const commentsView: JSX.Element = this.getCommentTimeline(kit);
    const firstNameLength: number = (PARTNER === 'ogath' || PARTNER === 'bdmsth') ? 30 : 12;
    const lastNameLength: number = (PARTNER === 'ogath' || PARTNER === 'bdmsth') ? 30 : 13;
    return (
      <Page title={i18next.t('cmp.header')}>
        {profileTransferConfirm.status ? profileTransferConfirm.form : undefined}
        {profileTransferSuccess.status ? profileTransferSuccess.form : undefined}
        {profileTransferError.status ? profileTransferError.form : undefined}
        {
          this.state.isOpen ?
            <ActivationPopup>
              <KitActivationPopup hidePopup={this.hideProfilePopup} oldBarcode={kit ? kit.barcode : ''} owner={profile?.owner} />
            </ActivationPopup> : undefined
        }
        {
          this.state.loading ? <LoadingIndicator show /> :
            <>
              {isShow ? <SquareButton buttonstyle={{ textColor: colors.primaryText, backgroundColor: colors.tealBlue, isFullwidth: true }} onClick={() => this.reportReleaseConfirmPopup()} >
                {i18next.t('dcm.transferReportButton')}
              </SquareButton> : undefined}
              {isSaved ? <Notification isColor="primary">{i18next.t('Your changes have been saved successfully')}</Notification> : undefined}
              <Formik initialValues={this.state}
                enableReinitialize={true}
                onSubmit={(values, actions) => this.handleSubmit(values, actions)}
                validationSchema={validationSchema}>
                {({ status, setFieldValue, values }) => (
                  <Form method="POST">
                    <Columns>
                      <Column>
                        <Container>
                          <Title isSize={6}>{i18next.t('dcm.title.profile')}</Title>
                          {(kit?.status === 'rejected' && isRecollect) ?
                            <RejectContainer>
                              <RejectHeader>
                                <Columns>
                                  <RejectText>
                                    <Columns>
                                      <Container>
                                        <img src={barcodeInfo} alt="" />
                                      </Container>
                                    </Columns>
                                  </RejectText>
                                  <RejectText>
                                    <Columns>
                                      <Container>
                                        {i18next.t('dcm.reject.text')}
                                      </Container>
                                    </Columns>
                                  </RejectText>

                                </Columns>
                                <SquareButton buttonstyle={{ textColor: colors.primaryText, backgroundColor: colors.red }} onClick={() => this.createProfilePopup()} >
                                  {i18next.t('dcm.activateButton')}
                                </SquareButton>
                                {/* Temporarily we removed it, future we can add if they want
                                 <SquareButton onClick={() => this.sendEmailToCSteam()} >
                                  {i18next.t('dcm.requestNewKitButton')}
                                </SquareButton> */}

                              </RejectHeader>
                            </RejectContainer> : undefined
                          }
                          <Card>
                            <CardHeaderContainer>
                              <div>{values.status}</div>
                              <div>{values.timestamp}</div>
                            </CardHeaderContainer>
                            <CardContent id="overview">

                              <Content>
                                <Title isSize={4}>{firstName} {lastName}</Title>
                                {barcodeField}
                                <FormField name="email" label={i18next.t(`cmp.table.title.email`)} noError>
                                  <ValueField>{values.email}</ValueField>
                                </FormField>
                                {
                                  isReportReady ?
                                    <FormField name="reportReleased" label={i18next.t(`cmp.table.title.reportReleased`)}>
                                      {isShow ? 'No' : 'Yes'}
                                    </FormField> : undefined
                                }
                              </Content>
                            </CardContent>
                          </Card>
                        </Container>
                        <Container>
                          <FieldContainer isHorizontal>
                            <FieldBody>
                              <FieldContainer className="half">
                                <Control>
                                  <FormField name="firstName" label={i18next.t(`cmp.table.title.firstName`)} >

                                    <Field name="firstName" className="input" value={values.firstName} maxLength={firstNameLength} placeholder={i18next.t('form.firstName.placeholder')} />

                                  </FormField>
                                </Control>
                              </FieldContainer>
                              <FieldContainer className="half">
                                <Control>
                                  <FormField name="lastName" label={i18next.t(`cmp.table.title.lastName`)} >
                                    <Field name="lastName" className="input" value={values.lastName} maxLength={lastNameLength} placeholder={i18next.t('form.lastName.placeholder')} />
                                  </FormField>
                                </Control>
                              </FieldContainer>
                            </FieldBody>
                          </FieldContainer>
                          <FieldContainer isHorizontal>
                            <FieldBody>
                              <FieldContainer className="half">
                                <Control>
                                  <FormField name="gender" label={i18next.t(`cmp.table.title.gender`)}>
                                    {(reports?.length) ? <ValueField>{values.gender ? GENDER[values.gender] : undefined}</ValueField> :
                                      <SelectField name="gender" className="input">
                                        <option value="">{i18next.t('form.sex.placeholder')}</option>
                                        {
                                          Object.keys(GENDER).map((value, key) => <option value={value} key={key}>{GENDER[value as Gender]}</option>)
                                        }
                                      </SelectField>
                                    }
                                  </FormField>
                                </Control>
                              </FieldContainer>
                              <FieldContainer className="half">
                                <Control>
                                  <FormField name="ethnicity" label={i18next.t(`cmp.table.title.ethnicity`)}>
                                    {(reports?.length) ? <ValueField>{values.ethnicity ? ETHNICITY[values.ethnicity] : undefined}</ValueField> :
                                      <SelectField name="ethnicity" className="input">
                                        <option value="">{i18next.t('form.ethnicity.placeholder')}</option>
                                        {
                                          Object.keys(ETHNICITY).map((value, key) => <option value={value} key={key}>{ETHNICITY[value as Ethnicity]}</option>)
                                        }
                                      </SelectField>
                                    }
                                  </FormField>
                                </Control>
                              </FieldContainer>
                            </FieldBody>
                          </FieldContainer>

                          <FieldContainer isHorizontal>
                            <FieldBody>
                              <FieldContainer className="half">
                                <Control>
                                  <FormField name="dob" label={i18next.t(`cmp.table.title.dob`)} >

                                    <DatePickerField
                                      name="dob"
                                      value={values.dob}
                                      onChange={setFieldValue}
                                    />
                                  </FormField>
                                </Control>
                              </FieldContainer>

                              {/* <FieldContainer className="half">
                                <Control>
                                  <FormField name="countryCode" label="Country Code" >
                                    <SelectField name="countryCode"
                                      className="input">
                                      <option value="" />
                                      {
                                        Object.keys(COUNTRY).map((value, key) => <option value={value} key={key}>{COUNTRY[value as CountryCode]}</option>)
                                      }
                                    </SelectField>
                                  </FormField>
                                </Control>
                              </FieldContainer> */}

                              <FieldContainer className="half">
                                <ContryCodeContainer>
                                  <Control>
                                    <FormField name="phone" label={i18next.t(`cmp.table.title.phone`)} >
                                      <div className="flex">
                                        <SelectFieldCountryCode name="countryCode"
                                          className="input">
                                          <option value="" />
                                          {
                                            Object.keys(COUNTRY).map((value, key) => <option value={value} key={key}>{COUNTRY[value as CountryCode]}</option>)
                                          }
                                        </SelectFieldCountryCode>
                                        <Field name="phone" maxLength={11} className="input" placeholder={i18next.t('form.phone.placeholder')} />
                                      </div>
                                    </FormField>
                                  </Control>
                                </ContryCodeContainer>
                              </FieldContainer>
                            </FieldBody>
                          </FieldContainer>

                          <FormField name="Remarks" label={i18next.t(`form.remark.label`)} noError>
                            <Field name="remarks" className="textarea" rows={4} cols={10} value={values.remarks} placeholder={i18next.t(`form.remark.placeholder`)} />
                          </FormField>
                          <FormError name="CustomerDetails" data={status} />
                          <SubmitButton>
                            {i18next.t('dcm.saveButton')}
                          </SubmitButton>

                        </Container>
                        {commentsView}
                      </Column>

                      <Column>
                        {values.reports?.length ? <Container>
                          <Title isSize={6}>{i18next.t('dcm.title.report')}</Title>
                          <Card>
                            <CardHeaderContainer>
                              <div>{values.reports && values.reports.length ? values.reports[0].name : ''}</div>

                              <ReportLanguageContainer>
                                {downloadReport}
                              </ReportLanguageContainer>

                              <DownloadPDF><p onClick={() => this.downloadPDF()}>{i18next.t('dcm.downloadPDFButton')}</p></DownloadPDF>

                            </CardHeaderContainer>

                            <CardContent>
                              <Button isSize="small" onClick={this.mobileBackBtnClickHandler}>
                                <FontAwesomeIcon icon={faChevronLeft} />
                              </Button>
                              <Content>
                                <MobileReportContainer title="mobile-report" src={mobileReportUrl} width="100%" />
                              </Content>
                            </CardContent>
                          </Card>

                        </Container> : undefined
                        }

                        <Container>
                          <Title isSize={6}>{i18next.t('dcm.title.status')}</Title>
                          <Table isFullWidth>
                            <thead>
                              <tr>
                                <TableHeader>{i18next.t('dcm.status')}</TableHeader>
                                <TableHeader>{i18next.t('dcm.statusTimestamp')}</TableHeader>
                              </tr>
                            </thead>
                            <tbody>
                              {values.kitHistory.map((status: Status, idx: number) => {
                                return (
                                  <tr key={idx}>
                                    <TableData key={`status_${idx}`}>{status.status}</TableData>
                                    <TableData key={`time_${idx}`}>{toLocalTime(status.datetime)}</TableData>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </Container>
                      </Column>
                    </Columns>
                  </Form>
                )}
              </Formik>
            </>
        }
        <FooterWrapper>
          <footer>
            <div className="content has-text-left">
              <p>
                {
                  <BreadcrumbLink className={'pageTitle'} to={'customers-management'}>
                    <FontAwesomeIcon icon={faChevronLeft} />  {i18next.t('cmp.header')}
                  </BreadcrumbLink>
                }
              </p>
            </div>
          </footer>
        </FooterWrapper>

      </Page>
    );
  }
  createProfilePopup = () => {
    this.setState({ isOpen: true });
  };
  sendEmailToCSteam = () => {
    console.log('Email has been sent');
  }
  reportReleaseConfirmPopup = () => {
    const targetStatus = !this.state.profileTransferConfirm.status;
    const profileTransferConfirm = {
      status: targetStatus,
      form: <ActivationPopup>
        <ConfirmationPopup
          alertTitle={i18next.t(`transfer.header`)}
          alertContent={i18next.t(`transfer.text`)}
          buttonName={i18next.t('transfer.confirmButton')}
          isSuccess={false}
          onCloseButtonClick={this.reportReleaseConfirmPopup}
          onSuccessCallback={this.reportTransferSuccessPopup} />
      </ActivationPopup>,
    };
    this.setState({
      profileTransferConfirm,
    });
  }

  reportReleaseSuccessPopup = () => {
    const targetStatus = !this.state.profileTransferSuccess.status;
    const profileTransferSuccess = {
      status: targetStatus,
      form: <ActivationPopup>
        <ConfirmationPopup
          alertTitle={i18next.t(`transferSuccess.header`)}
          alertContent={i18next.t(`transferSuccess.text`)}
          buttonName={i18next.t(`transferSuccess.closeButton`)}
          isSuccess={true}
          onCloseButtonClick={this.closeSuccessPopUp}
          onSuccessCallback={this.closeSuccessPopUp} />
      </ActivationPopup>,
    };
    this.setState({
      profileTransferSuccess,
    });
  }
  reportReleaseSuccessError = () => {
    const targetStatus = !this.state.profileTransferError.status;
    const profileTransferError = {
      status: targetStatus,
      form: <ActivationPopup>
        <ConfirmationPopup
          alertTitle={i18next.t(`transferError.header`)}
          subheading={i18next.t(`transferError.text.0`)}
          alertContent={i18next.t(`transferError.text.1`)}
          buttonName={i18next.t(`transferError.closeButton`)}
          isSuccess={true}
          onCloseButtonClick={this.closeSuccessPopUp}
          onSuccessCallback={this.closeSuccessPopUp} />
      </ActivationPopup>,
    };
    this.setState({
      profileTransferError,
    });
  }
  closeSuccessPopUp = async () => {
    this.setState(prevState => ({
      profileTransferConfirm: {
        ...prevState.profileTransferConfirm,
        status: false,
      },
      profileTransferSuccess: {
        ...prevState.profileTransferSuccess,
        status: false,
      },
      profileTransferError: {
        ...prevState.profileTransferError,
        status: false,
      },
    }));
    this.refresh(this.state.barcode);
    return;
  };
  refresh = async (barcode: string) => {
    await this.props.fetchKitsByBarcode(barcode);
  }
  reportTransferSuccessPopup = async () => {
    const { profile, kit } = this.props.customerDetails;
    if (profile) {
      await this.props.downloadPDFReport({ profileId: profile.profileId, owner: profile?.owner, lang: this.state.reportSelectedLang });
      const { pdfLink } = this.props.customerDetails;
      const language = getCurrentAppLang(true).split('_')[1];
      const email = (profile.email.find(e => e.name === EmailTagName.b2bcustomer && e.email) || profile.email.find(e => e.primary && e.email) || { email: '-' }).email;
      const transferPayload: ProfileTransferPayload = {
        profileId: profile?.profileId || '',
        owner: profile?.owner || '',
        email: email,
        destination: {
          owner: '',
          username: email,
        },
        transferredEmail: {
          barcode: kit?.barcode || '-',
          email: email,
          firstName: profile.name.firstName,
          language,
          profileId: profile.profileId,
          reportLink: pdfLink,
        },
      };
      await this.props.transferProfile(transferPayload, getPartner());
      const { transferStatus } = this.props.transfer;
      if (!transferStatus) {
        this.reportReleaseSuccessError();
      } else {
        this.reportReleaseConfirmPopup();
        this.reportReleaseSuccessPopup();
      }
    }
  }
  hideProfilePopup = (newBarcode?: string) => {
    this.setState({ isOpen: false });
    const { kit } = this.props.customerDetails;
    if (newBarcode && kit) {
      const url = window.location.href;
      window.location.href = url.replace(kit?.barcode, newBarcode);
    }
  }
  isShowReportRelease(kit: Kit, profile: Profile) {
    const { tag } = profile;
    const isReportReady = (kit.status === 'ready' && kit.test !== undefined && kit.test.some(test => test.status === 'report-ready'));
    if (isReportReady) {
      const emailtobe = tag.find(s => s.tag.startsWith(EmailTagName.tag));
      const ownerTag = tag.find(s => s.tag.startsWith('ownershipTransferred'));
      return !ownerTag && emailtobe ? true : false;
    }
    return false;
  }

  getDestinationProfile(profile: Profile) {
    const { tag } = profile;
    const index = tag.findIndex(s => s.tag.includes(EmailTagName.tag));
    const tagObject: string[] = tag[index].tag.split(',');
    const email = tagObject[1].split(':')[1];
    return ({ email });
  }
  getDetails(kit: Kit, profile: Profile, kitStatusFilter: KitStatus | undefined) {
    kit.history && kit.history.sort(byDatetime);
    const latestStatusDateTime = ((kit.history && kit.history[0]) || { datetime: '' }).datetime;
    this.setState({
      email: (profile.email.find(e => e.name === EmailTagName.b2bcustomer && e.email) || profile.email.find(e => e.primary && e.email) || { email: '-' }).email,
      firstName: profile.name.firstName || '-',
      lastName: profile.name.lastName || '-',
      gender: profile.health.gender,
      ethnicity: profile.health.ethnicity,
      dob: profile.health.dob ? moment(profile.health.dob).format('DD-MMM-YYYY') : '-',
      phone: getPhoneNumber(profile.phone).phoneNo || '-',
      countryCode: getPhoneNumber(profile.phone).countryCode || '-',
      barcode: kit.barcode || '-',
      status: <KitStatusIndicator status={kit.status} reportReady={isReportReady(kit, kitStatusFilter)} isReportRelesed={isReportRelesed(kit)} />,
      timestamp: latestStatusDateTime ? moment(latestStatusDateTime).format('YYYY-MM-DD HH:mm') : '-',
      reports: kit?.test?.filter(i => i.status === 'report-ready'),
      kitHistory: getTimeLines([kit]),
    });
  }

  getRejectedNote(kit: Kit) {
    if (kit.status === 'rejected') {
      const kitStatus = kit.history && kit.history.find(kitHistory => kitHistory.status === 'rejected');
      return kitStatus ? kitStatus.comment : '';
    } else {
      const { metadata } = kit;
      if (metadata && metadata.length > 0) {
        return metadata[metadata.length - 1].content;
      }
    }
  }
  getCommentTimeline(kit: Kit | undefined) {
    const sorted = kit && kit.metadata.sort((s1, s2) => toMoment(s2.datetime).diff(toMoment(s1.datetime)));
    const commentView: JSX.Element[] | undefined = sorted && sorted.map((metaData, i) => {
      return (
        <tr key={`${metaData.metadataId}`}>
          <td>{metaData.content}</td>
          <td>{toLocalTime(metaData.datetime)}</td>
          <td>{metaData.actor}</td>
        </tr>
      );
    });
    const comentsTable = sorted && sorted.length > 0 ?
      <> <Label>{i18next.t(`form.remark.label`)}</Label>
        <Table isBordered isStriped isNarrow>
          <thead>
            <tr>
              <th>{i18next.t(`dcm.comment.text`)}</th>
              <th>{i18next.t(`cmp.table.title.timestamp`)}</th>
              <th>{i18next.t(`dcm.user`)}</th>
            </tr>
          </thead>
          <tbody>
            {commentView}
          </tbody>
        </Table>
      </> : <Label />;
    return comentsTable;
  }
}

const Container = styled.div`
  margin-top:10px;
  margin-bottom:1em;
  label {
    padding:0;
    width:8em;
  }
  .input,.error {
    padding-left:0 !important;
  }
  .half {
    max-width: 49%;
  }
  #overview {
    div {
      box-shadow:none;
      padding:0;
    }
  }
`;

const BreadcrumbLink = styled(Link)`
  color: ${colors.text};
`;
const RejectedBarcodeView = styled.div`
  color: ${colors.red};
`;
const FooterWrapper = styled(Footer)`
  padding:0rem;
  font-size:1.5rem;
  font-weight:bold;
  background-color: inherit;
`;

const DownloadPDF = styled.div`
  cursor: pointer;
  color:${colors.selectedColor};
`;

const ReportLanguageContainer = styled.div`
  color:${colors.selectedColor};
  position: absolute;
  right: 7em;
  .selected-item {
    font-weight: normal !important;
  }
`;

const MobileReportContainer = styled.iframe`
  height:60vh;
`;

const CardHeaderContainer = styled(CardHeader)`
  padding:0.75em 1.5em;
  justify-content: space-between;
`;

const ValueField = styled.div`
  padding: 1px 0;
`;

const TableHeader = styled.th`
  color: ${colors.lightGreyColor} !important;
  font-size: 0.875em;
  border-width: 0 0 1px !important;
`;

const TableData = styled.td`
  border: 0 !important;
  text-transform: capitalize;
`;

const RejectContainer = styled.div`
  background-color: ${colors.red};
  color: ${colors.primaryText};
  border-radius: 8px;
  border: 2px solid red;
  padding: 10px;
  margin: 5px;`;

const RejectHeader = styled.div`
  padding: 10px;
`;
const RejectText = styled.div`
  padding:1.5em 2.2em 0.5em 1em;
  font-size: 1.2em;
`;
const mapStateToProps = (state: AppState) => {
  return {
    authentication: state.authentication,
    customerDetails: state.customerDetails,
    customerOverview: state.customerOverview,
    transfer: state.profileTransfer,
  };
};

const mapDispatchToProps = (dispatch: CustomerThunkDispatch) => {
  return {
    fetchKitsByBarcode: (barcode: string) => dispatch(actionFetchKitsByBarcode(barcode)),
    setPageTitle: (title: React.ReactNode) => dispatch(actionSetPageTitle({ pageTitle: title })),
    downloadPDFReport: (payload: DownloadReportFormPayload) => dispatch(actionDownloadPdfReport(payload)),
    transferProfile: (payload: ProfileTransferPayload, partner: string) => dispatch(actionTransferProfile(payload, partner)),
    resetPage: () => dispatch(actionResetCustomerDetails()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetails);